import React from 'react';
import { RxReload } from 'react-icons/rx';
import { BsThreeDotsVertical } from 'react-icons/bs';

const JobLeadsHeader = ({ onReload, onAddJob, isLoading, searchTerm, onSearchChange }) => (
  <div className="flex justify-between items-center gap-2 p-3">
    <div className="flex gap-2">
      <button
        onClick={onReload}
        className="p-2 hover:bg-gray-100 rounded cursor-pointer"
        title="Refresh"
        disabled={isLoading}
      >
        <RxReload size={20} className={isLoading ? 'animate-spin' : ''} />
      </button>
      <BsThreeDotsVertical size={20} className="mt-2" />
    </div>

    <div className="search-bar width-90">
      <input
        type="text"
        value={searchTerm}
        onChange={onSearchChange}
        placeholder="Search by job title, vendor, client, technology..."
        className="search-input border-radius-10 w-full px-4 py-2 border border-gray-300 rounded-lg"
      />
    </div>

    <button onClick={onAddJob} className="py-3 px-6 bg-secondary-700 text-white rounded-full hover:bg-secondary-800">
      <span className="mr-3">+</span>
      Add Job
    </button>
  </div>
);

export default JobLeadsHeader;
